/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

export function getHighlightedPhoto (photos) {
  return photos.find((photo) => photo.highlighted)
}
